import { createWebSocketSendActions } from './createFetchActions';

const falconSubscribeActions = createWebSocketSendActions('FALCON_SUBSCRIBE');

export { falconSubscribeActions };
